module.exports = __webpack_public_path__ + "img/icon-loading-blue.9bd402a6.svg";